import React, { useState } from 'react';
import { Modal, Button, Alert } from '@/components/ui';
import { toast } from 'sonner';

interface AssetImportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onImport: (data: any[]) => Promise<void>;
}

export function AssetImportModal({ isOpen, onClose, onImport }: AssetImportModalProps) {
  const [file, setFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleImport = async () => {
    if (!file) {
      toast.error('Vui lòng chọn file Excel');
      return;
    }

    setIsUploading(true);
    try {
      // In a real app, we would parse the Excel file here
      // For now, we simulate the import process
      await new Promise(resolve => setTimeout(resolve, 2000));
      await onImport([]); // Pass empty array as mock
      toast.success('Import tài sản thành công');
      onClose();
    } catch (error: any) {
      toast.error('Lỗi khi import: ' + error.message);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Import Tài sản từ Excel"
      size="md"
    >
      <div className="space-y-6 py-4">
        <Alert variant="info" icon="ri-information-line">
          Vui lòng tải file mẫu và điền đầy đủ thông tin tài sản (Mã tài sản, Tên, Loại, Số lượng, Zone...) để hệ thống tự động mapping.
        </Alert>

        <div className="flex flex-col items-center justify-center border-2 border-dashed border-slate-200 rounded-xl p-8 bg-slate-50 hover:bg-slate-100 transition-colors cursor-pointer" onClick={() => document.getElementById('fileInput')?.click()}>
          <input
            id="fileInput"
            type="file"
            className="hidden"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
          <i className="ri-file-excel-2-line text-4xl text-emerald-500 mb-2" />
          <p className="text-sm font-bold text-slate-700">
            {file ? file.name : 'Nhấn để chọn hoặc kéo thả file Excel vào đây'}
          </p>
          <p className="text-xs text-slate-400 mt-1">Hỗ trợ định dạng .xlsx, .xls</p>
        </div>

        <div className="flex justify-between items-center">
          <Button variant="ghost" icon="ri-download-line" size="sm">Tải file mẫu</Button>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>Hủy</Button>
            <Button 
              variant="primary" 
              icon="ri-upload-cloud-line" 
              onClick={handleImport}
              isLoading={isUploading}
              disabled={!file}
            >
              Bắt đầu Import
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
